var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "editor-invitee-list-empty-message" }, [
    _c("div", {
      staticClass: "icon icon-reminder editor-invitee-list-empty-message__icon"
    }),
    _vm._v(" "),
    _c("div", { staticClass: "editor-invitee-list-empty-message__caption" }, [
      _vm._v("\n\t\t" + _vm._s(_vm.$t("calendar", "No reminders yet")) + "\n\t")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }